import { styled } from '../styled';

export const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  '& .complete h3': {
    textAlign: 'center',
  },
  '& .ms-Button': {
    marginTop: '10px',
    marginBottom: '10px',
    backgroundColor: 'transparent',
  },
  variants: {
    loading: {
      false: {
        '& .ms-Button': {
          borderColor: '#2e94eb',
          color: '#2e94eb',
        },
      },
      true: {
        '& .ms-Button': {
          borderColor: '#a19f9d',
        },
      },
    },
  },
});
